// extracted by mini-css-extract-plugin
export default {"header":"header_header__X9J9d","main-image":"header_main-image__Owy-N"};